import { HelmetProvider } from "@dr.pogodin/react-helmet";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import i18n from "config/i18n";
import { createBrowserHistory } from "history";
import { useState } from "react";
import { I18nextProvider } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter, unstable_HistoryRouter as HistoryRouter } from "react-router";
import store from "store";

const Providers = ({
	children,
	reduxProviderOptions,
	reduxStoreOptions,
	reduxStore,
	routerProviderOptions,
	i18nextProviderOptions,
	isHistoryRouter,
}) => {
	const { history, ...restOfRouterProviderOptions } = routerProviderOptions || {};
	const RouteProvider = isHistoryRouter ? HistoryRouter : BrowserRouter;
	const reduxProviderStore = reduxStore || store({ ...(reduxStoreOptions || {}) });
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: { retry: 1 },
				},
			})
	);
	return (
		<HelmetProvider>
			<I18nextProvider i18n={i18n} {...(i18nextProviderOptions || {})}>
				<ReduxProvider {...{ store: reduxProviderStore, ...(reduxProviderOptions || {}) }}>
					<QueryClientProvider client={queryClient}>
						<RouteProvider
							{...{
								...(restOfRouterProviderOptions || {}),
								history: history || createBrowserHistory({}),
							}}>
							{children}
						</RouteProvider>
					</QueryClientProvider>
				</ReduxProvider>
			</I18nextProvider>
		</HelmetProvider>
	);
};

export default Providers;
